/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Invite = {
    /**
     * ID of the invite
     */
    id: string;
    /**
     * ID of the workspace
     */
    workspaceId: string;
    createdBy: string;
    acceptedBy: string | null;
    email: string;
    position: Invite.position;
    status: Invite.status;
    acceptedAt: string | null;
    created: string;
    updated: string;
    _object: Invite._object;
};
export namespace Invite {
    export enum position {
        OWNER = 'owner',
        ADMIN = 'admin',
        MEMBER = 'member',
        READ_ONLY = 'read-only',
    }
    export enum status {
        PENDING = 'pending',
        ACCEPTED = 'accepted',
        EXPIRED = 'expired',
        REVOKED = 'revoked',
    }
    export enum _object {
        INVITE = 'invite',
    }
}

